const getPagesCounter = (totalItems = 10) => {
  const itemsOnPage = 20;
  const results = Math.ceil(totalItems / itemsOnPage);
  return results;
};

const getRange = (start, end) => {
  let length = end - start + 1;
  return Array.from({ length }, (_, idx) => idx + start);
};

export const pagination = {
  getPagesCounter,
  getRange,
};



// WEBPACK FOOTER //
// ./src/_shared/utils/pagination.js